// extracted by mini-css-extract-plugin
export default {"Seleventh":"Seleventh_Seleventh__U8eQd","wrap":"Seleventh_wrap__9ZbiF","title":"Seleventh_title__T-V5G","img_wrap":"Seleventh_img_wrap__BnVQO","img":"Seleventh_img__B9IkK"};